import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/DesignActions";
import {loadDesignJobs} from "../helper functions/LoadDesignJobs";

export function DesignCompleteList() {
    const {instance} = useMsal();
    const account = useAccount();

    const dispatch = useDispatch()
    let sort = useSelector(state => state.designSortComplete);
    let search = useSelector(state => state.designSearchComplete);
    let filter = useSelector(state => state.designJobFilterCompleted);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>

                <div className="page-title-sh26">
                    <h1>Completed Design jobs</h1>
                    <p> These are design jobs where the customer has chosen a favourite design</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => dispatch(actions.SortNew("COMPLETE"))}>Newest First</a>
                        <a onClick={sort => dispatch(actions.SortOld("COMPLETE"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("COMPLETE"))}>A-Z</a>
                    </div>
                </div>
                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.completeSearch(document.getElementById("search-input").value, "COMPLETE"))}> 🔍
                    </button>
                </div>


                <div className="page-break"></div>
                <br/>

                {loadDesignJobs(sort, search, filter)}

                <div className="page-break"></div>

            </AuthenticatedTemplate>
        </div>
    );
}
